<div class="all-in-one-bank-statement-verification">
  <div class="container-fluid bg-white vh-100 p-0">
    <!-- Client Logo Component -->
    <ClientLogo v-if="this.$route.name != 'behalf_application'" />

    <!-- Breadcrumb Component -->
    <BreadCrumb label="Bank Statement Verification" />    
    <!-- Main Content -->
    <div class="main-bank-content py-3 px-2 px-md-3">
      <div class="row">
        <div class="col-lg-8 offset-md-1 offset-lg-2">
          <!-- Header Section -->
          <div class="verification-header text-center mb-3 mb-md-4">
            <p class="text-muted small px-2">
              Please provide your information to continue with the verification
              process
            </p>
          </div>          <!-- Step Indicator -->
          <div class="step-indicator mb-3 mb-md-4">
            <div
              class="step"
              :class="{
                  active: current_step >= 1,
                  completed: current_step > 1,
                }"
            >
              <div class="step-number">1</div>
              <div class="step-label d-none d-sm-block">Personal Info</div>
              <div class="step-label d-sm-none">Info</div>
            </div>
            <div
              class="step-line"
              :class="{ completed: current_step > 1 }"
            ></div>
            <div
              class="step"
              :class="{
                  active: current_step >= 2,
                  completed: current_step > 2,
                }"
            >
              <div class="step-number">2</div>
              <div class="step-label d-none d-sm-block">Bank Selection</div>
              <div class="step-label d-sm-none">Bank</div>
            </div>
            <div
              class="step-line"
              :class="{ completed: current_step > 2 }"
            ></div>
            <div
              class="step"
              :class="{
                  active: current_step >= 3,
                  completed: current_step > 3,
                }"
            >
              <div class="step-number">3</div>
              <div class="step-label">Method</div>
            </div>
            <div
              class="step-line"
              :class="{ completed: current_step > 3 }"
            ></div>
            <div class="step" :class="{ active: current_step >= 4 }">
              <div class="step-number">4</div>
              <div class="step-label">Process</div>
            </div>
          </div>

          <!-- Personal Information Form -->
          <transition name="slide-fade" mode="out-in">
            <div
              v-if="current_step === 1"
              class="card shadow-sm border bg-white mb-2"
            >
              <div class="card-header bg-light border-0">
                <h6 class="mb-0 text-dark">
                  <i class="fas fa-user me-2"></i>
                  Personal Information
                </h6>
              </div>
              <div class="card-body p-3 p-md-4">
                <div class="row">
                  <div class="col-12 col-md-6 mb-3">
                    <label class="form-label fw-semibold text-xs"
                      >First Name <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      v-model="first_name"
                      :disabled="is_field_disabled.first_name"
                      placeholder="Enter your first name"
                      required
                    />
                    <div
                      v-if="validation_errors.first_name"
                      class="text-danger text-sm mt-1"
                    >
                      {{ validation_errors.first_name }}
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-3">
                    <label class="form-label fw-semibold text-xs"
                      >Last Name <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      v-model="last_name"
                      :disabled="is_field_disabled.last_name"
                      placeholder="Enter your last name"
                      required
                    />
                    <div
                      v-if="validation_errors.last_name"
                      class="text-danger text-sm mt-1"
                    >
                      {{ validation_errors.last_name }}
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label fw-semibold text-xs"
                    >ID Number <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    v-model="id_number"
                    :disabled="is_field_disabled.id_number"
                    placeholder="Enter your ID number"
                    required
                  />
                  <div
                    v-if="validation_errors.id_number"
                    class="text-danger text-sm mt-1"
                  >
                    {{ validation_errors.id_number }}
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label fw-semibold text-xs"
                    >Email Address <span class="text-danger">*</span></label
                  >
                  <input
                    type="email"
                    class="form-control form-control-modern"
                    v-model="email"
                    :disabled="is_field_disabled.email"
                    placeholder="Enter your email address"
                    required
                  />
                  <div
                    v-if="validation_errors.email"
                    class="text-danger text-sm mt-1"
                  >
                    {{ validation_errors.email }}
                  </div>
                </div>

                <!-- Step 1 Continue Button -->
                <div class="text-end mt-4">
                  <button
                    type="button"
                    class="btn btn-bg-green shadow-sm rounded-small text-xs px-4 py-2"
                    @click="proceed_to_step_2"
                    :disabled="!can_proceed_to_step_2"
                  >
                    <span>Continue</span>
                    <i class="fas fa-arrow-right ms-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </transition>

          <!-- Bank Selection Form -->
          <transition name="slide-fade" mode="out-in">
            <div
              v-if="current_step === 2"
              class="card shadow-sm border bg-white mb-2"
            >
              <div class="card-header bg-light border-0">
                <h6 class="mb-0 text-dark">
                  <i class="fas fa-university me-2"></i>
                  Bank Selection
                </h6>
              </div>
              <div class="card-body p-3 p-md-4">
                <p class="text-muted mb-3 small px-1">
                  Please select your bank from the options below:
                </p>

                <!-- Error display for bank selection -->
                <div
                  v-if="validation_errors.selected_bank"
                  class="alert alert-danger text-sm mt-1 mb-3"
                >
                  {{ validation_errors.selected_bank }}
                </div>

                <!-- Bank Selection Visual Grid -->
                <div class="bank-selection-grid">
                  <div class="mb-4">
                    <div class="row g-2">
                      <div
                        v-for="bank in list_a_banks"
                        :key="bank.value"
                        class="col-6 col-sm-4 col-md-3 mb-2 mb-md-3"
                      >
                        <div
                          class="bank-card p-2 p-md-3 text-center shadow-sm rounded border h-100"
                          :class="{
                              'border-primary bg-light':
                                selected_bank === bank.value,
                            }"
                          @click="
                              selected_bank = bank.value;
                              handle_bank_selection();
                            "
                        >
                          <div class="bank-icon mb-1 mb-md-2">
                            <img
                              :src="bank.svg_path"
                              :alt="bank.title"
                              class="bank-logo-img"
                              width="40"
                              height="40"
                            />
                          </div>
                          <div class="bank-name small fw-semibold">
                            {{ bank.title }}
                          </div>
                        </div>
                      </div>
                      <div
                        v-for="bank in list_b_banks"
                        :key="bank.value"
                        class="col-6 col-sm-4 col-md-3 mb-2 mb-md-3"
                      >
                        <div
                          class="bank-card p-2 p-md-3 text-center shadow-sm rounded border h-100"
                          :class="{
                              'border-primary bg-light':
                                selected_bank === bank.value,
                            }"
                          @click="
                              selected_bank = bank.value;
                              handle_bank_selection();
                            "
                        >
                          <div class="bank-icon mb-1 mb-md-2">
                            <img
                              :src="bank.svg_path"
                              :alt="bank.title"
                              class="bank-logo-img"
                              width="40"
                              height="40"
                            />
                          </div>
                          <div class="bank-name small fw-semibold">
                            {{ bank.title }}
                          </div>
                        </div>
                      </div>
                      <div class="col-6 col-sm-4 col-md-3 mb-2 mb-md-3">
                        <div
                          class="bank-card p-2 p-md-3 text-center shadow-sm rounded border h-100"
                          :class="{
                              'border-primary bg-light':
                                selected_bank === 'other',
                            }"
                          @click="
                              selected_bank = 'other';
                              handle_bank_selection();
                            "
                        >
                          <div class="bank-icon mb-1 mb-md-2">
                            <div class="other-bank-icon">
                              <i
                                class="fas fa-plus-circle fa-2x"
                                :class="{
                                    'text-primary': selected_bank === 'other',
                                    'text-secondary': selected_bank !== 'other'
                                  }"
                              ></i>
                            </div>
                          </div>
                          <div class="bank-name small fw-semibold">
                            Other Bank
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Other Bank Input Field - Only shown when "Other Bank" is selected -->
                <div class="mb-3" v-if="selected_bank === 'other'">
                  <label class="form-label fw-semibold text-xs">
                    Bank Name <span class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    v-model="other_bank_name"
                    placeholder="Enter your bank name"
                    required
                  />
                  <div
                    v-if="validation_errors.other_bank_name"
                    class="text-danger text-sm mt-1"
                  >
                    {{ validation_errors.other_bank_name }}
                  </div>
                </div>
                <!-- Step Navigation Buttons -->
                <div class="d-flex flex-column flex-sm-row justify-content-between gap-2 mt-4">
                  <button
                    type="button"
                    class="btn btn-bg-secondary shadow-sm rounded-small text-xs px-4 py-2 order-2 order-sm-1"
                    @click="back_to_step_1"
                  >
                    <i class="fas fa-arrow-left me-2"></i>
                    Back
                  </button>
                  <button
                    type="button"
                    class="btn btn-bg-green shadow-sm rounded-small text-xs px-4 py-2 order-1 order-sm-2"
                    @click="proceed_to_step_3"
                    :disabled="!can_proceed_to_bank_selection"
                  >
                    Continue
                    <i class="fas fa-arrow-right ms-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </transition>

          <!-- Verification Method Selection -->
          <transition name="slide-fade" mode="out-in">
            <div
              v-if="current_step === 3"
              class="card shadow-sm border bg-white mb-2"
            >
              <div class="card-header bg-light border-0">
                <h6 class="mb-0 text-dark">
                  <i class="fas fa-shield-alt me-2"></i>
                  Verification Method
                </h6>
              </div>
              <div class="card-body p-3 p-md-4">
                <!-- List A Banks - Online & Manual Options -->
                <div v-if="is_list_a_bank" class="verification-options">
                  <p class="text-muted mb-3 small px-1">
                    Choose your preferred verification method:
                  </p>
                  <div class="row g-2 g-md-3">
                    <div class="col-12 col-md-6 mb-2 mb-md-3">
                      <div
                        class="status-card-simple shadow-sm border mb-2"
                        :class="{
                            'border-primary bg-light':
                              verification_method === 'online',
                            'bg-white': verification_method !== 'online',
                          }"
                        @click="select_verification_method('online')"
                      >
                        <div
                          class="status-icon-simple"
                          :class="{
                              'text-primary': verification_method === 'online',
                            }"
                        >
                          <i class="fas fa-globe"></i>
                        </div>
                        <div class="status-content-simple">
                          <div class="status-label-simple">Online Banking</div>
                          <div class="status-value-simple">
                            Connect securely through your online banking
                          </div>
                          <div
                            v-if="verification_method === 'online'"
                            class="text-primary mt-2 text-xs"
                          >
                            <i class="fas fa-check-circle me-1"></i> Selected
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 mb-2 mb-md-3">
                      <div
                        class="status-card-simple shadow-sm border mb-2"
                        :class="{
                            'border-primary bg-light':
                              verification_method === 'manual',
                            'bg-white': verification_method !== 'manual',
                          }"
                        @click="select_verification_method('manual')"
                      >
                        <div
                          class="status-icon-simple"
                          :class="{
                              'text-primary': verification_method === 'manual',
                            }"
                        >
                          <i class="fas fa-file-upload"></i>
                        </div>
                        <div class="status-content-simple">
                          <div class="status-label-simple">Manual Upload</div>
                          <div class="status-value-simple">
                            Upload your bank statements manually
                          </div>
                          <div
                            v-if="verification_method === 'manual'"
                            class="text-primary mt-2 text-xs"
                          >
                            <i class="fas fa-check-circle me-1"></i> Selected
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Validation error message for verification method -->
                  <div
                    v-if="validation_errors.verification_method"
                    class="text-danger text-sm mt-1 mb-3"
                  >
                    {{ validation_errors.verification_method }}
                  </div>
                </div>
                <!-- Step Navigation Buttons -->
                <div class="d-flex flex-column flex-sm-row justify-content-between gap-2 mt-4">
                  <button
                    type="button"
                    class="btn btn-bg-secondary shadow-sm rounded-small text-xs px-4 py-2 order-2 order-sm-1"
                    @click="back_to_step_2"
                  >
                    <i class="fas fa-arrow-left me-2"></i>
                    Back
                  </button>
                  <button
                    type="button"
                    class="btn btn-bg-green shadow-sm rounded-small text-xs px-4 py-2 order-1 order-sm-2"
                    @click="proceed_to_step_4"
                    :disabled="!can_proceed_to_step_3"
                  >
                    Continue
                    <i class="fas fa-arrow-right ms-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </transition>

          <!-- Processing Step -->
          <transition name="slide-fade" mode="out-in">
            <div
              v-if="current_step === 4"
              class="card shadow-sm border bg-white mb-2"
            >
              <div class="card-header bg-light border-0">
                <h6 class="mb-0 text-dark">
                  <i class="fas fa-cog me-2"></i>
                  Review & Process
                </h6>
              </div>              <div class="card-body p-3 p-md-4">
                <!-- Online Banking Integration -->
                <div
                  v-if="verification_method === 'online'"
                  class="online-banking-integration mb-4"
                >
                  <div v-if="!bank_account_id" class="text-center p-3 p-md-4">
                    <div class="text-center">
                      <div
                        class="spinner-border text-primary mb-3"
                        role="status"
                      >
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <p class="text-muted mb-0">
                        Connecting to {{ selected_bank_display }}...
                      </p>
                      <p class="small text-muted mt-2">
                        Please wait while we establish a secure connection
                      </p>
                    </div>
                  </div>
                  <div v-else class="iframe-container">
                    <!-- Mobile friendly iframe -->
                    <iframe
                      :src="external_link"
                      width="100%"
                      :height="screen_width ? 400 : 500"
                      frameborder="0"
                    ></iframe>
                  </div>
                </div>

                <!-- Bank Statement Uploads for Manual Method -->
                <div
                  v-if="verification_method === 'manual' || is_other_bank"
                  class="bank-statement-uploads mb-4"
                >
                  <div
                    class="status-card-simple shadow-sm border border-info mb-3"
                  >
                    <div class="status-icon-simple text-info">
                      <i class="fas fa-info-circle"></i>
                    </div>
                    <div class="status-content-simple">
                      <div class="status-value-simple small">
                        Please upload your bank statements for verification (Max
                        6 files).
                      </div>
                    </div>
                  </div>
                  <div class="upload-section mb-3">
                    <div
                      class="file-upload-area"
                      @dragover.prevent
                      @dragenter.prevent
                      @drop.prevent="handle_file_drop"
                      @click="trigger_file_upload"
                    >
                      <input
                        type="file"
                        ref="file_input"
                        @change="handle_file_upload"
                        multiple
                        accept=".pdf"
                        style="display: none"
                      />
                      <div
                        v-if="selected_files.length === 0"
                        class="upload-placeholder p-2 p-md-3"
                      >
                        <i
                          class="fas fa-cloud-upload-alt mb-2"
                          style="font-size: 1.5rem"
                        ></i>
                        <p class="mb-1">
                          <span class="d-none d-md-inline">Drag and drop your bank statements here or </span>
                          <span class="fw-semibold text-primary">click to browse</span>
                        </p>
                        <p class="text-muted small mb-0">
                          PDF (Max 6 files)
                        </p>
                        
                      </div>
                      <div v-else class="file-list p-2 p-md-3">
                        <div
                          v-for="(file, index) in selected_files"
                          :key="index"
                          class="file-item mb-2"
                        >
                          <div
                            class="d-flex align-items-center justify-content-between p-2 border rounded"
                          >
                            <div class="d-flex align-items-center flex-grow-1 min-width-0">
                              <i class="fas fa-file-alt me-2 text-primary flex-shrink-0"></i>
                              <span
                                class="text-truncate small"
                                :title="file.name"
                                >{{ file.name }}</span
                              >
                            </div>
                            <button
                              type="button"
                              class="btn btn-sm text-danger ms-2 flex-shrink-0"
                              @click.stop="remove_file(index)"
                            >
                              <i class="fas fa-times"></i>
                            </button>
                          </div>
                        </div>
                        <button
                          type="button"
                          class="btn btn-bg-green rounded-small text-xs btn-sm mt-2 w-100 w-sm-auto"
                          @click.stop="trigger_file_upload"
                          v-if="selected_files.length < 6"
                        >
                          <i class="fas fa-plus me-1"></i> Add More Files
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Action Buttons -->
                <div class="d-flex flex-column flex-sm-row justify-content-between gap-2">
                  <button
                    type="button"
                    class="btn btn-bg-secondary shadow-sm rounded-small text-xs px-4 py-2 order-2 order-sm-1"
                    @click="back_from_process"
                  >
                    <i class="fas fa-arrow-left me-2"></i>
                    <span v-if="is_list_b_bank || is_other_bank" class="d-none d-sm-inline">Back to Bank Selection</span>
                    <span v-else class="d-none d-sm-inline">Back to Verification Method</span>
                    <span class="d-sm-none">Back</span>
                  </button>
                  <button
                    v-if="verification_method === 'manual' || is_other_bank"
                    type="button"
                    class="btn btn-bg-green shadow-sm rounded-small text-xs px-4 py-2 order-1 order-sm-2"
                    @click="proceed_verification"
                    :disabled="is_processing"
                  >
                    <span v-if="is_processing">
                      <i class="fas fa-spinner fa-spin me-2"></i>
                      Processing...
                    </span>
                    <span v-else>
                      <i class="fas fa-check me-2"></i>
                      Start Verification
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</div>
